import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const userBoardRoute: InvariantJiraRoute = {
	name: 'rapidboard-user-board',
	path: '/jira/people/:accountId/boards/:boardId',
};
